import React from 'react';
import { gql, TypedDocumentNode } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { useParams } from 'react-router-dom';
import { LookRecommendationsQuery, LookRecommendationsQueryVariables } from '../../generated/types';
import { LookRecommendation, LOOK_RECOMMENDATION_FRAGMENT } from './LookRecommendation';

const LOOK_RECOMMENDATIONS_QUERY: TypedDocumentNode<
  LookRecommendationsQuery,
  LookRecommendationsQueryVariables
> = gql`
  query LookRecommendationsQuery($variantId: String!, $countryCode: String) {
    variant(id: $variantId) {
      id
      recommendation_looks {
        ...LookRecommendationFragment
      }
    }
  }
  ${LOOK_RECOMMENDATION_FRAGMENT}
`;

export const LookRecommendations: React.FC = () => {
  const { variantId } = useParams<{ variantId: string }>();
  const { data } = useQuery(LOOK_RECOMMENDATIONS_QUERY, {
    variables: { variantId },
    skip: !variantId
  });

  if (!data?.variant?.recommendation_looks) return null;

  return (
    <>
      {data.variant.recommendation_looks.map(look => (
        <LookRecommendation key={look.id} variantId={variantId} look={look} />
      ))}
    </>
  );
};
